// Shared expand/collapse for `button.js-disclosure[aria-expanded][aria-controls]`.
// Pages style the panel with `[aria-expanded="true"] + panel { max-height: none }`
// over a collapsed `max-height: 0`. Collapsed panels are `inert` so their links
// leave the tab order; render them with `inert` server-side too.
document.addEventListener("click", function (evt) {
  var button = evt.target.closest(".js-disclosure");
  if (!button) return;
  var panel = document.getElementById(button.getAttribute("aria-controls"));
  if (!panel) return;

  // Animate from/to the measured height, since max-height: none can't transition
  panel.style.maxHeight = panel.scrollHeight + "px";

  if (button.getAttribute("aria-expanded") === "true") {
    panel.inert = true;
    panel.offsetHeight; // flush the measured height so the collapse animates
    button.setAttribute("aria-expanded", "false");
    panel.style.maxHeight = "";
  } else {
    panel.inert = false;
    button.setAttribute("aria-expanded", "true");
    panel.addEventListener("transitionend", function handler() {
      panel.style.maxHeight = "";
      panel.removeEventListener("transitionend", handler);
    });
  }
});
